import React, { useState,useEffect } from 'react';
import axios from 'axios';
import { showToast,ToastMessage } from '../../Shared/ToastMessage';
import { baseUrl } from '../../../api/common';

const CurrencyAdd = ({fetchCurrencyData,addPopupStatus, handleAddPopup, eventType, updateData}) => {

  const [updateId, setUpdateId] = useState("");

  const [formValues, setFormValues] = useState({
    currency_name:"",
    currency_symbol:"",
    currency_code:""
  });

  const [errors, setErrors] = useState({
    currencyName:"",
    currencySymbol:"",
    currencyCode:""
  });

  const handleInputChange = (field, value) => {
    setFormValues({ ...formValues, [field]: value });
  };

  const validate = () => {
    const newErrors = {
        currencyName:"",
        currencySymbol:"",
        currencyCode:""
    };  
    if (!formValues.currency_name.trim()) {
      newErrors.currencyName = 'Currency name cannot be empty';
    }  
    if (!formValues.currency_symbol) {
      newErrors.currencySymbol = 'Currency symbol cannot be empty';
    }
    if (!formValues.currency_code) {
        newErrors.currencyCode = 'Currency code cannot be empty';
    }  
    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === '');
  };  

  const clearInputValues = () => {
    setErrors({
        currencyName:"",
        currencySymbol:"",
        currencyCode:""
    });
    setFormValues({
        currency_name:"",
        currency_symbol:"",
        currency_code:""
    });
    handleAddPopup(false);
  };  

  const addUpdateCurrency = async () => {
    if (validate()) {
      console.log('Post Data:', formValues);   
      try {
        const requestData = {
          ...formValues,
          ...(eventType === "Update" && { id: updateId }),
        };
        console.log("Update requestData Data:", requestData);
        const response = await axios.post(
          `${baseUrl}/api/add_currency`,
          requestData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: localStorage.getItem('access_token'),
            },
          }
        );
        if (response.data.status) {
          showToast(response.data.message, 'success');
          fetchCurrencyData();
          clearInputValues();
        } else {
          showToast(response.data.message, 'error');
        }
      } catch (error) {
        console.error("Error during submission:", error);
        showToast("Submission failed. Please try again.", "error");
      }
    }
  };

  useEffect(() => {
    if (eventType === "Update" && updateData) {
      console.log("Update Data:", updateData);
      setUpdateId(updateData.id);
      setFormValues({
        currency_name: updateData.currency_name || '',
        currency_symbol: updateData.currency_symbol || '',
        currency_code: updateData.currency_code || ''  
      });
    }else{
      setErrors({
        currencyName:"",
        currencySymbol:"",
        currencyCode:""
    });
    setFormValues({
        currency_name:"",
        currency_symbol:"",
        currency_code:""
    });    
    }
  }, [eventType, updateData, addPopupStatus]);

  return (
    <>
    <ToastMessage/>    
    {addPopupStatus && (
      <div
        className={`extraspace_search_div search_div${addPopupStatus ? ' open' : ''}`}
      >
        <div className="card member_master_sidebar_scrool">
          <div className="member_edit_pop_flex mb-3 text-end">
            <h3>{eventType} Country</h3>
            <div className="input-group-append">
              <span
                onClick={() => clearInputValues()}
                className="search_toggle btn btn-danger"
              >
                <i className="fa fa-times" />
              </span>
            </div>
          </div>
          <div className="table-responsive">
            <div className="body application_body_side">
              <div>             
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group pos_relative">
                        <label>Currency Name</label>
                        <input
                          type="text"
                          className={`form-control ${errors.currencyName?"red_border":''}`}
                          value={formValues.currency_name}
                          onChange={(e) => handleInputChange('currency_name', e.target.value)} 
                          required
                        />
                        {errors && (                          
                            <p className="text-danger pos_abos">{errors.currencyName}</p>                          
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group pos_relative">
                        <label>Currency Symbol</label>
                        <input
                          type="text"
                          className={`form-control ${errors.currencySymbol?"red_border":''}`}
                          value={formValues.currency_symbol}
                          onChange={(e) => handleInputChange('currency_symbol', e.target.value)} 
                          required
                        />
                        {errors && (                          
                            <p className="text-danger pos_abos">{errors.currencySymbol}</p>                          
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group pos_relative">
                        <label>Currency Code</label>
                        <input
                          type="text"
                          className={`form-control ${errors.currencyCode?"red_border":''}`}
                          value={formValues.currency_code}
                          onChange={(e) => handleInputChange('currency_code', e.target.value)} 
                          required
                        />
                        {errors && (                          
                            <p className="text-danger pos_abos">{errors.currencyCode}</p>                          
                        )}
                      </div>
                    </div>
                    <div className="col-md-12 member_button_flex">
                      <button onClick={() => addUpdateCurrency()} className="btn btn-outline-info">
                      {eventType}
                      </button>
                      <a
                        onClick={() => clearInputValues()}
                        className="btn btn-outline-danger"
                      >
                        Close
                      </a>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
    </>
  );
};

export default CurrencyAdd;
